export default {
  //snackbar data
  showSnackbar: false,
  snackBarMessage: "",
  snackBarType: "warning",
  windowWidth: null, //used to access screen size changes in all component
  isMobileWindowSize: false, //to check mobile view window size
};
